var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 33.2797C17.0511 33.2797 16.8603 33.2007 16.7197 33.06C16.579 32.9194 16.5 32.7286 16.5 32.5297L16.5 16.0297C16.5 15.8994 16.5339 15.7713 16.5985 15.6581C16.6631 15.5449 16.7561 15.4504 16.8682 15.3841C16.9804 15.3177 17.108 15.2818 17.2383 15.2798C17.3686 15.2777 17.4972 15.3097 17.6114 15.3725L32.6114 23.6225C32.7291 23.6872 32.8273 23.7823 32.8956 23.8979C32.964 24.0135 33 24.1454 33 24.2797C33 24.414 32.964 24.5458 32.8956 24.6614C32.8273 24.777 32.7291 24.8722 32.6114 24.9369L17.6114 33.1869C17.5007 33.2478 17.3764 33.2797 17.25 33.2797ZM18 17.2979L18 31.2613L30.6936 24.2797L18 17.2979Z",
    fill: "#FA541C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.44775,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "#FA541C",
    strokeOpacity: 0.24,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.cc777cfd6a620c6cfa7a69cbdd89addd.svg";
export { ForwardRef as ReactComponent };